import {Logger} from './Logger';
import {Notifier} from './Notifier';
import * as Sentry from '@sentry/browser';

export let logger = new Logger(false, {});

export const initLogging = (environment: string, isSentryEnabled: boolean, sentryDsn: string = '') => {
    const sentryOptions = {
        dsn: sentryDsn,
        // integrations: [Sentry.browserTracingIntegration()],
        environment,
        tracesSampleRate: environment === 'production' ? 0.0001 : 1.0,
    };
    logger = new Logger(sentryDsn.length > 0 ? isSentryEnabled : false, sentryOptions);
};

export const notifier = new Notifier(logger);
